import { render } from "./ktTopicCheck.vue?vue&type=template&id=c27634fa&scoped=true"
import script from "./ktTopicCheck.vue?vue&type=script&lang=js"
export * from "./ktTopicCheck.vue?vue&type=script&lang=js"

import "./ktTopicCheck.vue?vue&type=style&index=0&id=c27634fa&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27634fa"]])

export default __exports__